import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Select from 'react-select'
import {DndProvider} from "react-dnd";
import {HTML5Backend} from "react-dnd-html5-backend";
import {ProposalRow} from './ProposalRow';
import moment from 'moment';
import QuestionIcon from "./Components/QuestionIcon";
import smallSelect2Styles from "./Components/smallSelect2Styles";

let _disabled = false;

class Role
{
    constructor(id, name, rate) {
        this.id = id;
        this.name = name;
        this.rate = rate;
    }
}
class Staff {
    constructor(id, firstName, lastName, role, callName, team, contractor, active, leaderOf) {
        this.id = id;
        this.firstName = firstName;
        this.lastName = lastName;
        this.role = role;
        this.callName = callName;
        this.team = team;
        this.contractor = contractor;
        this.active = active;
        this.leaderOf = leaderOf;
    }
}
class LineItem {
    constructor(id, sort) {
        this.id = id;
        this.description = '';
        this.allocations = {};
        this.sort = sort;
    }
}
class Allocation {
    constructor(id, hours, lineItem, rate, role, staff) {
        this.id = id;
        this.hours = hours;
        this.proposalStaffLineItem = lineItem;
        this.rate = rate;
        this.role = role;
        this.staff = staff;
    }

}

class ProposalRole {
    constructor(id, roleId, rate, sort) {
        this.id = id;
        this.roleId = roleId;
        this.rate = rate;
        this.sort = sort;
    }
}



class Proposal extends React.Component {
    constructor(props) {
        super(props);
        this.handleDeleteStaffButtonClick = this.handleDeleteStaffButtonClick.bind(this);
        this.getAllSelectedStaff = this.getAllSelectedStaff.bind(this);
        this.handleOnStaffRoleSelectionChange = this.handleOnStaffRoleSelectionChange.bind(this);
        this.handleAddStaffRoleButtonClick = this.handleAddStaffRoleButtonClick.bind(this);
        // this.onRoleChange = this.onRoleChange.bind(this);
        // this.onStaffChange = this.onStaffChange.bind(this);
        // this.onHoursChange = this.onHoursChange.bind(this);
        // this.calculateCostTotals = this.calculateCostTotals.bind(this);
        this.calculateHourAndCostTotals = this.calculateHourAndCostTotals.bind(this);
        this.updateRateForRole = this.updateRateForRole.bind(this);
        this.getStaffRoleAllocationsForRole = this.getStaffRoleAllocationsForRole.bind(this);
        this.getAllocationForRoleStaffFromLineItem = this.getAllocationForRoleStaffFromLineItem.bind(this);
        this.submitFormData = this.submitFormData.bind(this);
        this.buildFormData = this.buildFormData.bind(this);

        //
        // const proposalDuration = (moment(props.endDate, 'DD/MM/YYYY').toDate().getTime() - moment(props.startDate, 'DD/MM/YYYY').toDate().getTime()) / (1000 * 3600 * 24);
        this.state = {
            selectedAllocationCoordinates : {y: null, roleIndex: null, sraIndex: null},
            updateRateForRoleId : null,
            missingStaff : [],
            staffUtilisationSummary: {},
            staffUtilisationDaily: [],
            submitForm: false,
            showStaffRoleSelection: false,
            showSuccess: false,
            errorMessage: null,
            date: props.date,
            dateData:  {startDate : moment(props.startDate, 'DD/MM/YYYY'), endDate : moment(props.endDate, 'DD/MM/YYYY')},
            startDate: props.startDate,
            endDate: props.endDate,
            clientID: props.clientID,
            proposalID: props.proposalID,
            allRoles: {},
            allStaffLookup: {},
            allStaffSorted: [],
            allRolesSorted: [],
            proposalRoles: {},
            selectedRoles: [],
            lineItems: {},
            hourTotals: [],
            costTotals: [],
            standardRatesForSelectedRolesLookup: {},
            hourGrantTotal: 0,
            costGrandTotal: 0,
        }

    }
    componentWillMount() {
        var allRoles = {};
        var allRolesSorted = [];
        var allStaffLookup = {};
        var allStaffSorted = [];
        var allRolesSorted = [];
        var ajax = new XMLHttpRequest();
        ajax.open("GET", '/admn/roles/get_list', false);
        ajax.onload = () => {
            var response = JSON.parse(ajax.responseText);

            response.forEach(function(e) {
                allRoles[e.id] = new Role(e.id, e.name, 0);
                allRolesSorted.push(allRoles[e.id]);
            });
        };

        ajax.send();
        var ajax = new XMLHttpRequest();
        ajax.open("GET", '/staff/list?showInactive=1', false);
        ajax.onload = () => {
            var response = JSON.parse(ajax.responseText);

            response.forEach(function(e) {
                allStaffLookup[e.id] = new Staff(e.id, e.firstName, e.lastName, e.role, e.callName, e.team, e.contractor, e.active);
                allStaffSorted.push(allStaffLookup[e.id]);
            });
        };
        ajax.send();

        var ajax2 = new XMLHttpRequest();
        ajax2.open("GET", '/proposal/' + this.state.proposalID + '/list_staff_items', false);
        ajax2.onload = () => {
            var response = JSON.parse(ajax2.responseText);
            this.populateDataFromAjaxResponseText(response, allRoles, allStaffLookup, allRolesSorted, allStaffSorted);
        };
        ajax2.send();
    }

    populateDataFromAjaxResponseText(response, allRoles, allStaff = null, allRolesSorted = null, allStaffSorted = null) {
        if (allStaff === null) {
            allStaff = Object.assign({}, this.state.allStaffLookup);
        }
        // console.log(response);
        // console.log(allStaff);
        var selectedRoles = [];

        if (response['staffLineItems']) {
            Object.values(response['staffLineItems']).forEach(function(lineItem) {
                lineItem.startDate = moment(lineItem.startDate, 'DD/MM/YYYY');
                lineItem.endDate = moment(lineItem.endDate, 'DD/MM/YYYY');
            });

            var lineItems = response['staffLineItems'];
            //populate sort values in case sort is missing
            lineItems = Object.fromEntries(Object.entries(lineItems)
                .sort(([i, o], [i2, o2]) => o.sort - o2.sort)
                .map(([i, o], index) => [i, {...o, sort: index}]));
        }


        if (response['proposalRoles']) {
            Object.values(response['proposalRoles']).forEach(function(proposalRole) {
                let roleId = proposalRole.role;
                let sort = proposalRole['sort'];
                selectedRoles[sort] = roleId;
                allRoles[roleId].rate = proposalRole.rate;
                allRoles[roleId].proposalRoleId = proposalRole.id;

                Object.values(proposalRole.staffRoleAllocations).forEach((staffRoleAllocation => {
                    allStaff[staffRoleAllocation.staff].role = proposalRole.role;
                }))

            });
        }

        this.staffActualChargesOnEnquiry = response.staffActualChargesOnEnquiry;

        this.setState({
            standardRatesForSelectedRolesLookup: response['standardRatesForSelectedRoles'],
            proposalRoles: response['proposalRoles'],
            selectedRoles: selectedRoles,
            lineItems: lineItems ? lineItems : this.state.lineItems,
            allRoles: allRoles,
            allStaffLookup: allStaff ? allStaff : this.state.allStaffLookup,
            allStaffSorted: allStaffSorted ? allStaffSorted : this.state.allStaffSorted,
            allRolesSorted: allRolesSorted ? allRolesSorted : this.state.allRolesSorted
        });

    }

    submitFormData(e, excludeLineItems=false) {
        e?.preventDefault();
        this.setState({
            submitForm: false,
            showSuccess: false,
            errorMessage: null
        });

        var allRoles = Object.assign({}, this.state.allRoles);


        var postData = {
            'stf_line_item_collection' : {'staffLineItems' : this.state.lineItems, 'roles' : this.state.proposalRoles},
            excludeLineItems: excludeLineItems
        };
        if (excludeLineItems) delete postData.stf_line_item_collection.staffLineItems;

        var formData = new FormData();
        this.buildFormData(formData, postData);

        fetch('/proposal/' + this.state.proposalID + '/edit_staff_items', {
            method: 'POST',
            body: formData
        })
            .then(res => {
                if (res.redirected) return Promise.reject('You are not logged in, please log on and then try again.');
                if (!res.ok) return Promise.reject(res.status);

                // console.log(res.text());
                // this.populateDataFromAjaxResponseText(res.json(), allRoles);
                return res.json();

            } )
            .then(data => {
                // console.log(data);
                this.populateDataFromAjaxResponseText(data, allRoles);
                this.setState({submitForm: false, showSuccess: !excludeLineItems});
                window.onbeforeunload = null;
            })
            .catch(error => {
                this.setState({submitForm: false, errorMessage: error.toString()});
                // console.log('Error occurred submitting data', error);
            });
            // .then(
            //     (result) => { this.setState({showSuccess: true}) },
            //     (error) => { console.log(error); this.setState({ showFailure: false, showSuccess:true, error: error })}
            //     );

        // this.setState({
        //     showSuccess: true
        // });


        // form.removeAllListeners();
        // form = document.querySelector('#proposal_form');
        // form.submit();
        return true;
    }
    buildFormData(formData, data, parentKey) {
        if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File) && !(moment.isMoment(data))) {
            Object.keys(data).forEach(key => {
                this.buildFormData(formData, data[key], parentKey ? `${parentKey}[${key}]` : key);
            });
        } else if (moment.isMoment(data)) {
            formData.append(parentKey, data.format('DD/MM/YYYY'))
        } else {
            const value = data == null ? '' : data;

            formData.append(parentKey, value);
        }
    }
    componentDidMount() {
        this.calculateHourAndCostTotals();
        // const dateData = {...this.state.dateData};

        // var btn_save = document.querySelector('#btn_save');
        // btn_save.addEventListener('click', this.submitFormData);

        var ajax = new XMLHttpRequest();
        var staffUtilisationSummary;
        ajax.open("GET", '/tasks/get_utilisation?daily=1&exclProposal=' + this.state.proposalID + '&task_filter[dateRange]=' + this.state.startDate + ' to ' + this.state.endDate, true);
        ajax.onload = () => {
            let response = JSON.parse(ajax.responseText);
            console.log('in onload');
            console.log(response);

            this.setState({
                staffUtilisationDaily: response.staffUtilisationDaily,
                staffUtilisationSummary: response.staffUtilisationSummary
            })
        };
        ajax.send();


        // window.addEventListener('focus',(e) => {
        //     console.log(this);
        //     this.setState({selectedAllocationCoordinates : {}});
        // });
        // dateData.proposalDurationDays = Object.values(staffUtilisationSummary)[0]?.periodDays;
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if ((this.state.lineItems !== prevState.lineItems)
            || (this.state.allRoles !== prevState.allRoles)
            || (this.state.selectedRoles !== prevState.selectedRoles)
        ) {
            this.calculateHourAndCostTotals();

            if (this.state.submitForm && !prevState.submitForm) {
                // console.log('submit form')
                setTimeout(() => {
                    if (this.state.updateRateForRoleId) {
                        // console.log('want to update rate');
                        this.updateRateForRole(this.state.updateRateForRoleId);
                        // console.log('rate updated');
                    }
                    // console.log('want to submit form');
                    this.submitFormData(null, true);
                }, 30);
            }
            this.setState({
                submitForm: false,
                showSuccess: false,
                errorMessage: null
            });
            window.onbeforeunload = function () {
                return 'Your changes may not be saved';
            };


        }

        // console.log(this.state.staffUtilisationSummary);
    }

    findMissingStaffAllocations = (hourTotals) => {
        var staffHours = [];

        Object.values(this.state.lineItems).forEach((lineItem) => {
            Object.values(lineItem.allocations).forEach((allocation) => {
                let staffRoleAllocation = allocation.staffRoleAllocation;
                let staffId = Object.values(this.state.proposalRoles).find(pr => pr.staffRoleAllocations[staffRoleAllocation])?.staffRoleAllocations[staffRoleAllocation].staff;
                console.log(allocation.staffRoleAllocation);

                if (hourTotals[allocation.staffRoleAllocation]) {
                    staffHours.push({staffId: staffId, hours: hourTotals[allocation.staffRoleAllocation]});
                }
                // staffAllocations[allocation.staffRoleAllocation]
                // staffAllocations.push(allocation.staffRoleAllocation);
            })
        })

        // var staffAllocated = staffAllocations.map(staffRoleAllocation => Object.values(this.state.proposalRoles).find(pr => pr.staffRoleAllocations[staffRoleAllocation])?.staffRoleAllocations[staffRoleAllocation].staff);


        // console.log(this.staffActualChargesOnEnquiry);
        // console.log(staffAllocated);

        console.log(staffHours, '****staff hours');

        let missingStaff = this.staffActualChargesOnEnquiry.filter(d => !staffHours.some(staffHoursObj => d.id == staffHoursObj.staffId && staffHoursObj.hours >= d.hoursWorked));



        let missingStaffNames = missingStaff.map(o => o.callName);
        // console.log(missingStaffNames);

        this.setState({
            'missingStaff' : missingStaffNames
        })



    }


    RoleAdd(evt) {
        //selected Roles: role objects: id: {id, name, rate}
        //line Items: {description: 1234, roleHours: {rId : hours, rId : hours ...}}
        var selectedRoleId = evt.target.value;
        var selectedRoles = this.state.selectedRoles.slice();
        selectedRoles.push(this.state.allRoles[selectedRoleId]);
        this.setState({
            selectedRoles: selectedRoles,
        })
    }

    // onStaffChange(roleId, index, evt) {
    //
    //     var lineItems = this.state.lineItems.slice();
    //     var proposalRoles = Object.assign({}, this.state.proposalRoles);
    //     let proposalRoleId = this.state.allRoles[roleId]['proposalRoleId'];
    //     var newStaffId = evt.target.value;
    //     var previousStaffId = proposalRoles[proposalRoleId]['staffMembers'][index];
    //
    //     if (this.state.allStaffLookup[newStaffId]['role'] != roleId) {
    //         alert('big proble.. tried to change staff to one that is in a different role');
    //     }
    //
    //     proposalRoles[proposalRoleId]['staffMembers'][index] = newStaffId;
    //
    //     console.log('index:'  + index);
    //     console.log('new staff:' + newStaffId);
    //     console.log('previous staff' + previousStaffId);
    //
    //     previousStaffId = previousStaffId ? previousStaffId : 0;
    //
    //     lineItems.forEach(function(lineItem) {
    //         if (typeof lineItem.allocations === 'object' && Object.keys(lineItem.allocations).length > 0) {
    //             Object.keys(lineItem.allocations).forEach(function(i){
    //                 var allocation = lineItem.allocations[i];
    //                 console.log(allocation);
    //                 //some other situations:
    //                 //1. If the previous staff is blank. If I make a blank staff zero,
    //                 if (allocation['staff'] == previousStaffId && allocation['role'] == roleId) {
    //                     lineItem.allocations[i]['staff'] = newStaffId;
    //                     // delete lineItem.allocations[i];
    //                 }
    //             });
    //         }
    //     });
    //
    //     console.log(lineItems);
    //     console.log(proposalRoles);
    //     this.setState({
    //         proposalRoles: proposalRoles,
    //         lineItems: lineItems
    //     })
    //
    //
    // }
    // onRoleChange(index, evt) {
    //     var lineItems = this.state.lineItems.slice();
    //     var allRoles = Object.assign({}, this.state.allRoles);
    //     var proposalRoles = Object.assign({}, this.state.proposalRoles);
    //     var changedSelectedRoleIndex = index;
    //     var newRoleId = evt.target.value;
    //     var selectedRoles = this.state.selectedRoles.slice();
    //     var previousRole = selectedRoles[changedSelectedRoleIndex];
    //     var newRole = evt.target.value;
    //     selectedRoles[changedSelectedRoleIndex] = newRole;
    //
    //
    //     this.updateRateForRole(evt.target.value, allRoles);
    //
    //     let proposalRoleId = allRoles[previousRole] ? allRoles[previousRole].proposalRoleId : Math.floor((Math.random() * 1000000) + 1);
    //     // console.log(proposalRoleId);
    //     if (!proposalRoles[proposalRoleId]) proposalRoles[proposalRoleId] = {}
    //     proposalRoles[proposalRoleId].role = newRole;
    //     proposalRoles[proposalRoleId].rate = allRoles[newRole].rate;
    //     proposalRoles[proposalRoleId].sort = index;
    //     // proposalRoles[proposalRoleId].id = null;
    //     if (allRoles[previousRole]) allRoles[previousRole].proposalRoleId = null;
    //     allRoles[newRole].proposalRoleId = proposalRoleId;
    //
    //         //copy previous role setup to new role
    //     lineItems.forEach(function(lineItem) {
    //         if (typeof lineItem.allocations === 'object' && Object.keys(lineItem.allocations).length > 0) {
    //             Object.keys(lineItem.allocations).forEach(function(i){
    //                 var allocation = lineItem.allocations[i];
    //                 if (allocation['role'] == previousRole) {
    //                     lineItem.allocations[i] = {'staff' : 0, 'role' : newRole, 'rate' : allRoles[newRole]['rate'], 'hours' : allocation['hours']}
    //                     // delete lineItem.allocations[i];
    //                 }
    //             });
    //         }
    //     });
    //
    //     this.setState({
    //         proposalRoles: proposalRoles,
    //         allRoles: allRoles,
    //         selectedRoles: selectedRoles,
    //         lineItems: lineItems
    //     })
    // }

    updateRateForRole(roleID, allRoles = null) {
        if (allRoles === null) {
            allRoles = Object.assign({}, this.state.allRoles);
        }
        var proposalRoles = Object.assign({}, this.state.proposalRoles);
        //update rate for selected role
        var ajax = new XMLHttpRequest();
        ajax.open("GET", '/rate/calculateByParameters?roleID='+ roleID + '&date='+this.state.date+'&clientID='+this.state.clientID, false);
        ajax.onload = function () {
            var response = JSON.parse(ajax.responseText);

            var rate = response ? response.Rate : 0;

            allRoles[roleID].rate = rate;
            proposalRoles[allRoles[roleID]['proposalRoleId']].rate = rate;
            // console.log('rate set');
            // proposalRoles[allRoles[roleID]['proposalRoleId']].rate = rate;
        };


        ajax.send();

        this.setState({
            submitForm: false,
            allRoles: allRoles,
            proposalRoles: proposalRoles,
            updateRateForRoleId: null
        })
    }

    onDescriptionChange = (lineItemId, text) => {
        var lineItems = Object.assign({}, this.state.lineItems);
        // lineItems[lineItemId].name = evt?.target?.value;
        // if (source == 'user') {
        lineItems[lineItemId].name = text;
        this.setState({
            lineItems: lineItems
        });
        // }
    }

    onDateRangeChange = (lineItemId, v) => {
        var lineItems = Object.assign({}, this.state.lineItems);
        lineItems[lineItemId].startDate = v[0];
        lineItems[lineItemId].endDate = v[1];

        this.setState({
            lineItems: lineItems
        });
    }

    onHoursChange = (lineItemId, staffRoleAllocation, evt) => {
        this.modifyHoursAllocation(lineItemId, staffRoleAllocation, evt.target.value);
    }

    modifyHoursAllocation = (lineItemId, staffRoleAllocation, hours) => {
        if (!staffRoleAllocation.id) return;

        // var lineItems = this.state.lineItems.slice();
        var lineItems = Object.assign({}, this.state.lineItems);
        let allocation = this.getAllocationForRoleStaffFromLineItem(lineItems[lineItemId], staffRoleAllocation);
        let allocationId = allocation ? allocation.id : Math.floor((Math.random() * 1000000) + 1);


        // console.log(this.state.lineItems);
        // console.log(lineItemId);
        // console.log(lineItems);

        if (isNaN(parseInt(hours))) {
            delete lineItems[lineItemId].allocations[allocationId];
        } else {
            lineItems[lineItemId].allocations[allocationId] = {id: allocationId, hours : hours, staffRoleAllocation : staffRoleAllocation.id};
        }

        this.setState({
            lineItems: lineItems,
        });

    }

    handleRateChange(roleId, e) {
        var allRoles = Object.assign({}, this.state.allRoles);
        var proposalRoles = Object.assign({}, this.state.proposalRoles);
        // var lineItems = this.state.lineItems.slice();
        allRoles[roleId].rate = e.target.value;
        proposalRoles[allRoles[roleId]['proposalRoleId']].rate = e.target.value;

        // lineItems.forEach(function(lineItem) {
        //     if (typeof lineItem.allocations === 'object' && Object.keys(lineItem.allocations).length > 0) {
        //         Object.keys(lineItem.allocations).forEach(function(i){
        //             var allocation = lineItem.allocations[i];
        //             if (allocation['role'] == roleId) {
        //                 lineItem.allocations[i].rate = e.target.value;
        //             }
        //         });
        //     }
        // });

        this.setState({
            proposalRoles: proposalRoles,
            // lineItems: lineItems,
            allRoles: allRoles
        })
    }

    handleAddRoleButtonClick(e) {
        e.preventDefault();
        var selectedRoles = this.state.selectedRoles.slice();
        selectedRoles.push(0);
        this.setState({
            selectedRoles: selectedRoles,
        })
    }

    handleOnStaffRoleSelectionChange(e, currentStaffId, currentRoleId, currentStaffRoleAllocationId = null) {
        //we need to ...
        //go through the add role logic
        //go through the change role logic
        //go through the change staff logic
        //create new add staff logic
        // console.log(e);

        // console.log(currentRoleId);
        const [roleOrStaff, id] = e.value.split('_');
        if (roleOrStaff == 'staff') {
            var selectedStaffId = id;
            var selectedStaff = this.state.allStaffLookup[selectedStaffId];
            var selectedRole = (selectedStaffId == 0 && currentRoleId) ?
                this.state.allRoles[currentRoleId] : this.state.allRoles[selectedStaff['role']];
        } else {
            var selectedStaffId = 0;
            var selectedStaff = this.state.allStaffLookup[selectedStaffId];
            var selectedRole = this.state.allRoles[id];
        }

        // console.log(selectedRole);

        let proposalRoleId = null;
        var selectedRoles = this.state.selectedRoles.slice();
        var allRoles = Object.assign({}, this.state.allRoles);
        let proposalRoles = Object.assign({}, this.state.proposalRoles);
        // var lineItems = Object.assign({}, lineItems);
        // var lineItems = this.state.lineItems.slice();
        var currentStaffIndexToBeSwapped = null;
        var currentRoleIndexToBeSwapped = null;


        // console.log('before if v2');
        if (currentRoleId) {
            // console.log('current role id: ' + currentRoleId);
            // console.log('do we get here?');
            //don't do anything if the same staff has been re selected
            if (currentStaffId === null) currentStaffId = 0;
            if (currentRoleId == selectedRole.id && currentStaffId == selectedStaffId) return;


            let currentStaff = this.state.allStaffLookup[currentStaffId];
            let currentRole = this.state.allRoles[currentRoleId];
            let currentProposalRoleId = allRoles[currentRole.id].proposalRoleId;

            // const [currentStaffIndex, s] = Object.entries(proposalRoles[currentProposalRoleId].staffRoleAllocations)
            //                                 .find(([k,s]) => s.staff == currentStaffId);
            // console.log('current staff role allocation:');
            // console.log(currentStaffRoleAllocationId);
            const currentStaffIndex = currentStaffRoleAllocationId;
            if (currentRole.id == selectedRole.id) {
                if (currentStaffIndex >= 0)
                    currentStaffIndexToBeSwapped = currentStaffIndex;
                //we're going to need need current Staff Index so that new staff is in the same column in the role
            } else {
                var staffRoleAllocationToBeShifted = proposalRoles[currentProposalRoleId].staffRoleAllocations[currentStaffIndex];
                delete proposalRoles[currentProposalRoleId].staffRoleAllocations[currentStaffIndex];


                if (Object.keys(proposalRoles[currentProposalRoleId].staffRoleAllocations).length === 0) {
                    if (allRoles[currentRole.id]) {
                        delete proposalRoles[currentProposalRoleId];
                        allRoles[currentRole.id].proposalRoleId = null;
                    }

                    const currentRoleIndex = selectedRoles.findIndex(e => e == currentRole.id);
                    //if the role we're switching to doesn't already exist, put it in the same column as the old role
                    if (!selectedRoles.find(rId => rId == selectedRole.id)) {
                        currentRoleIndexToBeSwapped = currentRoleIndex;
                    } else {
                        selectedRoles.splice(currentRoleIndex,1);
                    }
                }

            }
        }

        // console.log(selectedRole);
        //if its a new role, we need to add it to selected roles and the update the rate
        var updateRateForRoleId = null;
        if (!this.state.selectedRoles.find(v => v == selectedRole.id)) {
            updateRateForRoleId = selectedRole.id;
            if (currentRoleIndexToBeSwapped !== null) {
                selectedRoles[currentRoleIndexToBeSwapped] = selectedRole.id;
            } else {
                selectedRoles.push(selectedRole.id);
            }
            // this.updateRateForRole(selectedRole.id, allRoles);
            // console.log('after calling update rate for role');

            proposalRoleId = Math.floor((Math.random() * 1000000) + 1);
            proposalRoles[proposalRoleId] = {}
            proposalRoles[proposalRoleId].role = selectedRole.id;
            proposalRoles[proposalRoleId].rate = allRoles[selectedRole.id].rate;
            proposalRoles[proposalRoleId].sort = currentRoleIndexToBeSwapped !== null ? currentRoleIndexToBeSwapped : selectedRoles.length;
            proposalRoles[proposalRoleId].staffRoleAllocations = {};

            allRoles[selectedRole.id]['proposalRoleId'] = proposalRoleId;


        } else if (roleOrStaff == 'staff') {
            //the first section of this function handles primary cases of
            //changing an existing staff/role to a new one
            //the below catches a scenario where legacy entries do not have a staff,
            //and we are trying to add a new staff to a role that already has
            //entries with no staff record
            if (currentStaffId == null) currentStaffId = 0;
            if (currentRoleId == null) currentRoleId = this.state.selectedRoles.find(v => v == selectedRole.id);
        }

        proposalRoleId = allRoles[selectedRole.id]['proposalRoleId'];

        //The role is staying the same but the staff is being swapped
        if (currentStaffIndexToBeSwapped !== null) {
            // console.log('we are swapping a staff index');
            // console.log(currentStaffIndexToBeSwapped);
            // console.log(proposalRoles[proposalRoleId].staffMembers[currentStaffIndexToBeSwapped]);
            proposalRoles[proposalRoleId].staffRoleAllocations[currentStaffIndexToBeSwapped].staff = selectedStaffId;
        } else {
            //role and staff are changing
            // console.log('proposal role id: ' + proposalRoleId);
            // console.log('selected role id:' + selectedRole.id);

            var staffRoleAllocationToBeAdded = {};
            if (staffRoleAllocationToBeShifted) {
                staffRoleAllocationToBeAdded = staffRoleAllocationToBeShifted;
            } else {
                staffRoleAllocationToBeAdded = {
                    // id: Math.floor((Math.random() * 1000000) + 1)
                    id: null
                }

            }
            staffRoleAllocationToBeAdded.staff = selectedStaffId;
            staffRoleAllocationToBeAdded.proposalRole = proposalRoleId;
            proposalRoles[proposalRoleId].staffRoleAllocations[Math.floor((Math.random() * 1000000))] = staffRoleAllocationToBeAdded;
        }


        proposalRoles = this.getProposalsRoleSortsBasedOnSelectedRoles(proposalRoles, selectedRoles);

        this.setState({
            updateRateForRoleId: updateRateForRoleId,
            submitForm: true,
            // lineItems: lineItems,
            proposalRoles: proposalRoles,
            allRoles: allRoles,
            selectedRoles: selectedRoles,
            showStaffRoleSelection: false,
        });






    }

    getProposalsRoleSortsBasedOnSelectedRoles(proposalRoles, selectedRoles) {
        var updatedProposalRoles = {};
        // return Object.entries(proposalRoles).map(([key, pr]) => {
        //     return pr;
        // })
        for (const key in proposalRoles) {
            var pr = proposalRoles[key];
            pr.sort = selectedRoles.findIndex(roleId => roleId == pr.role);
            updatedProposalRoles[key] = pr;
        }

        return updatedProposalRoles;
    }

    // handleDeleteRoleButtonClick(selectedRoleId, selectedRoleIndex, e) {
    //     e.preventDefault();
    //     var selectedRoles = this.state.selectedRoles.slice();
    //     var proposalRoles = Object.assign({}, this.state.proposalRoles);
    //     var allRoles = Object.assign({}, this.state.allRoles);
    //     var lineItems = this.state.lineItems.slice();
    //
    //     if (allRoles[selectedRoleId]) {
    //         delete proposalRoles[allRoles[selectedRoleId].proposalRoleId];
    //         allRoles[selectedRoleId].proposalRoleId = null;
    //     }
    //     selectedRoles.splice(selectedRoleIndex,1);
    //
    //     lineItems.forEach(function(value) {
    //         Object.keys(value.allocations).forEach(function(index){
    //             var roleId = index;
    //
    //             if (roleId == selectedRoleId) {
    //                 delete value.allocations[index];
    //             }
    //         }.bind(this));
    //     }.bind(this));
    //
    //     this.setState({
    //         allRoles: allRoles,
    //         proposalRoles: proposalRoles,
    //         lineItems: lineItems,
    //         selectedRoles: selectedRoles,
    //     })
    // }

    handleDeleteStaffButtonClick(staffRoleAllocation, index, e) {
        // console.log('in delete staff function');
        //delete staff from staffList in proposalRole
        var proposalRoles = Object.assign({}, this.state.proposalRoles);
        var lineItems = Object.assign({}, this.state.lineItems);
        // var lineItems = this.state.lineItems.slice();
        var allRoles = Object.assign({}, this.state.allRoles);
        var selectedRoles = this.state.selectedRoles.slice();
        // const roleId = this.state.allStaffLookup[staffId].role;
        const proposalRoleId = staffRoleAllocation.proposalRole;

        delete proposalRoles[proposalRoleId].staffRoleAllocations[staffRoleAllocation.id];

        Object.values(lineItems).forEach(function(value) {
            Object.keys(value.allocations).forEach(function(index){
                var allocation = value.allocations[index];

                if (allocation.staffRoleAllocation == staffRoleAllocation.id) {
                    delete value.allocations[index];
                }
            }.bind(this));
        }.bind(this));

        if (Object.keys(proposalRoles[proposalRoleId].staffRoleAllocations).length === 0) {
            var roleId = proposalRoles[proposalRoleId].role;
            if (allRoles[roleId]) {
                delete proposalRoles[proposalRoleId];
                allRoles[roleId].proposalRoleId = null;
            }

            const selectedRoleIndex = selectedRoles.findIndex(e => e == roleId);
            selectedRoles.splice(selectedRoleIndex,1);
        }

        proposalRoles = this.getProposalsRoleSortsBasedOnSelectedRoles(proposalRoles, selectedRoles);

        // console.log(proposalRoles);
        // console.log(lineItems);

        this.setState({
            allRoles: allRoles,
            selectedRoles: selectedRoles,
            proposalRoles: proposalRoles,
            lineItems: lineItems,
        })
    }

    handleAddLineItemButtonClick(e, name = null) {
        if (e) e.preventDefault();
        // var lineItems = this.state.lineItems.slice();
        var lineItems = Object.assign({}, this.state.lineItems);
        const lineItemId = Math.floor((Math.random() * 1000000) + 1);
        lineItems[lineItemId] = new LineItem(lineItemId, Object.keys(lineItems).length);
        if (name) lineItems[lineItemId].name = name;

        lineItems[lineItemId].startDate = this.state.dateData.startDate;
        lineItems[lineItemId].endDate = this.state.dateData.endDate;


        // this.updateLineItemSorts(lineItems);

        this.setState({
            lineItems: lineItems
        })

        return lineItemId;

    }

    handleDeleteLineItemButtonClick = (lineItemId, e) => {
        e.preventDefault();
        var lineItems = Object.assign({}, this.state.lineItems);
        delete lineItems[lineItemId];

        lineItems = Object.fromEntries(Object.entries(lineItems)
            .sort(([i, o], [i2, o2]) => o.sort - o2.sort)
            .map(([i, o], index) => [i, {...o, sort: index}]));


        // this.updateLineItemSorts(lineItems);

        this.setState( {
            lineItems: lineItems
        });
    }

    // updateLineItemSorts = (lineItems) => {
    //     lineItems.forEach(function(lineItem, index) {
    //         lineItem.sort = index;
    //     });
    // }

    handleAddStaffRoleButtonClick(e) {
        e.preventDefault();

        this.setState({
                showStaffRoleSelection: !this.state.showStaffRoleSelection,
            }
        );

    }
    calculateHourAndCostTotals() {
        var hourTotals = {};
        var costTotals = {};
        var hourGrandTotal = 0;
        var costGrandTotal = 0;

        Object.values(this.state.lineItems).forEach(function(value) {
           Object.keys(value.allocations).forEach(function(index){
               var staffRoleAllocationId = value.allocations[index].staffRoleAllocation;
               var hours = value.allocations[index].hours;
               if (!hourTotals[staffRoleAllocationId]) hourTotals[staffRoleAllocationId] = 0;
               hourTotals[staffRoleAllocationId] = hourTotals[staffRoleAllocationId] + Number(hours);
               hourGrandTotal = hourGrandTotal + Number(hours);


               var rate = Object.values(this.state.proposalRoles).find(o => {
                   return Object.values(o.staffRoleAllocations).some(s => {
                       return s.id == staffRoleAllocationId
                   })
               })?.rate;
               if (!costTotals[staffRoleAllocationId]) costTotals[staffRoleAllocationId] = 0;
               // var roleId = Number(this.state.selectedRoles[roleID]);
               var cost = (Number(hours) * Number(rate)) || 0;
               costTotals[staffRoleAllocationId] = costTotals[staffRoleAllocationId] + cost;

               costGrandTotal = costGrandTotal + cost;

           }.bind(this));
        }.bind(this));

        this.findMissingStaffAllocations(hourTotals);

        this.setState({
            hourGrandTotal: hourGrandTotal,
            costGrandTotal: costGrandTotal,
            hourTotals: hourTotals,
            costTotals: costTotals
        });
    }

    getStaffRoleAllocationsForRole(roleId) {
        let staffList =  this.state.allRoles[roleId] ? Object.values(this.state.proposalRoles[this.state.allRoles[roleId]['proposalRoleId']]['staffRoleAllocations']) : [];

        // console.log(this.state.lineItems);
        // const hasAllocationWithBlankStaff = this.state.lineItems.find(lineItem => {
        //     for (const key in lineItem.allocations) {
                // console.log('check for match');
                // let match = lineItem.allocations[key].role == roleId && lineItem.allocations[key].staff == 0;
               // console.log('check role ' + roleId + 'for staff 0, allocation>>>>');
               // console.log(lineItem.allocations[key]);
                // if (match) console.log('we have a match v2');
                // if (match) return true;
                // return lineItem.allocations[key].role == roleId && lineItem.allocations[key].staff == 0;
            // }
            // return false;

        // });

        // if (staffList.length && hasAllocationWithBlankStaff && !(staffList.find(staff => staff === 0) >= 0)) staffList.push(0);

        // console.log('staff list for role ' + roleId + ': ');
        // console.log(staffList);
        // console.log('hasallocatiowithblankstaff?');
        // console.log(hasAllocationWithBlankStaff);


        //give each role a default dummy user if it has no user assigned
        // return staffList && staffList.length ? staffList : [0];
        return staffList && Object.keys(staffList).length ? staffList : [{}];
}

    getAllSelectedStaff() {
        let staffList = [];

        for (const i in this.state.proposalRoles) {
            staffList = staffList.concat(Object.values(this.state.proposalRoles[i]['staffRoleAllocations']).map(o => o.staff));
        }


        return staffList;
    }

    getAllocationForRoleStaffFromLineItem(lineItem, staffRoleAllocation) {
        if (!lineItem) return null;
        let allocations = lineItem.allocations;
        var allocationToReturn = null;
        for (const key in allocations) {
            let allocation = allocations[key];


            if (allocation && (allocation.staffRoleAllocation == staffRoleAllocation.id)) {
                // return allocation.hours;
                allocationToReturn = allocation;
            }
        }
        return allocationToReturn;
        // return a;
        // return null;
    }

    getHoursForRoleStaffFromLineItem = (lineItem, staffRoleAllocation) => {
        if (!staffRoleAllocation.id) return '';
        let allocation = this.getAllocationForRoleStaffFromLineItem(lineItem, staffRoleAllocation);
        // console.log(allocation);
        // console.log('in get hours function for role ' + role);
        // console.log(allocation);
        if (allocation) return allocation.hours;

        return '';

    }

    moveLineItem = (dragIndex, hoverIndex, dragItemId) => {
        // var lineItems = this.state.lineItems.slice();
        var lineItems = Object.assign({}, this.state.lineItems);
        const item = lineItems[dragItemId];


        var list =  Object.entries(lineItems)
            .sort(([i, o], [i2, o2]) => o.sort - o2.sort);

        list.splice(dragIndex,1);

        var lineItemsArr = Object.entries(lineItems)
                            .sort(([i, o], [i2, o2]) => o.sort - o2.sort);

        lineItemsArr.splice(dragIndex,1);
        lineItemsArr.splice(hoverIndex,0,[item.id, item]);
        lineItems = Object.fromEntries(lineItemsArr.map(([i, o], index) => [i, {...o, sort: index}]));



        // this.updateLineItemSorts(lineItems);

        this.setState({
            lineItems: lineItems
        });

    }

    render() {
        return (
            <form id='proposal_staff_charges' onSubmit={(e) => this.submitFormData(e)}>
            <div>
                {this.state.showSuccess ? <div className="alert-notice">Data Successfully Saved</div> : '' }
                {this.state.errorMessage ? <div className="alert-warning">Error Saving Data With Error: {this.state.errorMessage}</div> : '' }
                {this.state.missingStaff.length ? <div>Warning: Staff booked to this Enquiry are not allocated sufficient time: {this.state.missingStaff.join(', ')}</div> : '' }
                <table className="styled" style={{borderCollapse : 'collapse'}}>
                    <tbody>
                    <tr style={{'padding' : 0}}>
                        <td>Role</td>
                        {this.state.selectedRoles.map((selectedRoleId, i) => {
                            const roleName = this.state.allRoles[selectedRoleId]['name'];
                            const length = this.getStaffRoleAllocationsForRole(selectedRoleId).length * 13;
                            return (
                                <td className="role-border" colSpan={this.getStaffRoleAllocationsForRole(selectedRoleId).length} style={{'padding' : '0, 0.5em'}}>
                                    <div style={{ width: length + 'em', 'overflow' : 'scroll'}}>
                                        {/*<select style={{width: 18 +'em'}} onChange={(e) => this.onRoleChange(i, e)}>*/}
                                        {/*    <option>Select a role to add...</option>*/}
                                        {/*    {Object.keys(this.state.allRoles).map((i2) => {*/}
                                        {/*        //             if (!roles.find(e => e == allocation.role)) {*/}
                                        {/*        if (!(this.state.selectedRoles.find(e => e == this.state.allRoles[i2].id)) || selectedRoleId == this.state.allRoles[i2].id  ) {*/}
                                        {/*            return <option selected={(selectedRoleId == this.state.allRoles[i2].id) ? 'selected' : ''} value={this.state.allRoles[i2].id}>{this.state.allRoles[i2].name}</option>*/}
                                        {/*        }*/}
                                        {/*        // return <option>{this.state.allRoles[i2].name}</option>*/}
                                        {/*    })}*/}
                                        {/*</select>*/}
                                        {/*<a href='#' onClick={(e) => this.handleDeleteRoleButtonClick(selectedRoleId, i, e)} className='js-delete_collection_entry'>x</a>*/}
                                        {roleName}
                                        {/*{ roleName.length >= length ? roleName.slice(0,length - 3) + '...' : roleName }*/}
                                    </div>
                                </td>
                            );
                        })}
                        <td>
                            <div style={{width:'2.2em', position: 'relative'}}>
                            <a onClick={(e) => this.handleAddStaffRoleButtonClick(e)} title="Add Staff" className="js-add_collection_entry" href="#">
                                { this.state.showStaffRoleSelection ? 'x' : '+' }
                            </a>
                            {this.state.selectedRoles.length ? '' : <a onClick={(e) => this.handleAddStaffRoleButtonClick(e)} href="#">Add Staff</a> }
                            {this.state.showStaffRoleSelection ? (
                                <StaffRoleSelectionPopup
                                    allSelectedStaff={this.getAllSelectedStaff()}
                                    handleOnStaffRoleSelectionChange={this.handleOnStaffRoleSelectionChange}
                                    allStaffSorted={this.state.allStaffSorted}
                                    allRolesSorted={this.state.allRolesSorted}
                                    allStaffLookup={this.state.allStaffLookup}
                                    allRoles={this.state.allRoles}
                                    staffUtilisationSummary={this.state.staffUtilisationSummary}
                                />
                            ): ''}
                            </div>
                        </td>

                    </tr>
                    <tr>
                        <td>Role Rate</td>
                        {this.state.selectedRoles.map((selectedRoleId, i) => {
                            let showRateError = this.state.standardRatesForSelectedRolesLookup[selectedRoleId]?.standardRate === 999.99 && !this.state.standardRatesForSelectedRolesLookup[selectedRoleId]?.clientRate;
                            return (
                                <td className="role-border" colSpan={this.getStaffRoleAllocationsForRole(selectedRoleId).length} >
                                    <span
                                        className='currency_input'
                                        title={
                                            showRateError ?
                                                'You have selected a role which has no MEL Standard Rate – please see Chris Power to discuss the correct rate to be used' : ''
                                        }
                                        style={{
                                            position: 'relative'
                                        }}

                                    >
                                        $<input
                                            disabled={_disabled}
                                            type = "text"
                                            style={ {
                                                backgroundColor: showRateError ? 'red' : 'white'
                                            }}
                                            onChange={(e) => this.handleRateChange(selectedRoleId, e)} value={this.state.allRoles[selectedRoleId] ? this.state.allRoles[selectedRoleId].rate : ''} />
                                            { showRateError &&
                                                <span
                                                    style={{
                                                        position: 'absolute',
                                                        right: '5px'
                                                    }}
                                                >
                                                    <QuestionIcon style={{color: 'white', backgroundColor: 'black'}} />
                                                </span> }
                                    </span>
                                    <div className='d-flex gap-3 lh-sm'>
                                        <small className="text-body-tertiary d-flex flex-column"><span>Standard Rate</span> ${this.state.standardRatesForSelectedRolesLookup[selectedRoleId]?.standardRate}</small>
                                        <small className="text-body-tertiary d-flex flex-column"><span>Client Rate</span>{this.state.standardRatesForSelectedRolesLookup[selectedRoleId]?.clientRate ?
                                            `$${this.state.standardRatesForSelectedRolesLookup[selectedRoleId]?.clientRate}` : 'N/A'}</small>
                                    </div>
                                </td>
                            )
                        })}
                        <td></td>
                    </tr>
                    <tr style={{'padding' : 0}}>
                        <td>{Object.keys(this.state.lineItems).length ? 'Staff': 'No Staff Costing Estimate Entries Found, Please Add As Necessary'}</td>
                        {this.state.selectedRoles.map((selectedRoleId, i) => {
                            return (
                                this.getStaffRoleAllocationsForRole(selectedRoleId).map((staffRoleAllocation, i) => {
                                    let className = i === (this.getStaffRoleAllocationsForRole(selectedRoleId).length - 1) ? 'role-border' : 'staff-border';
                                    return (
                                        <td className={className}>
                                            <div style={{display:'flex', alignItems:'center'}}>
                                                <StaffRoleSelection
                                                    hideRoles={true}
                                                    allSelectedStaff={this.getAllSelectedStaff()}
                                                    handleOnStaffRoleSelectionChange={this.handleOnStaffRoleSelectionChange}
                                                    allStaffSorted={this.state.allStaffSorted}
                                                    allRolesSorted={this.state.allRolesSorted}
                                                    currentStaffId={staffRoleAllocation.staff}
                                                    currentRoleId={selectedRoleId}
                                                    small={true}
                                                    staffUtilisationSummary={this.getStaffUtilisationBasedOnDateSelections(staffRoleAllocation)}
                                                    hoursToBeBooked={this.state.hourTotals[staffRoleAllocation.id]}
                                                    currentStaffRoleAllocationId={staffRoleAllocation.id}
                                                />
                                                <a href='#'
                                                   style={{'width': '1.8em'}}
                                                   onClick={_disabled ? null : (e) => this.handleDeleteStaffButtonClick(staffRoleAllocation, i, e)}
                                                   className='js-delete_collection_entry'>x</a>
                                            </div>
                                        </td>)
                                })
                            );
                        })}
                        <td>
                            {/*<a style={{'margin-right' : '0.5em' }} onClick={(e) => this.handleAddRoleButtonClick(e)} title="Add Role" className="js-add_collection_entry" href="#">+</a>*/}
                            {/*{this.state.selectedRoles.length ? '' : <a onClick={(e) => this.handleAddRoleButtonClick(e)} href="#">Add Role</a> }*/}
                        </td>

                    </tr>
                    <tr>
                        <td>Total Hours</td>
                        {this.state.selectedRoles.map((roleId, i) => {
                                return (
                                this.getStaffRoleAllocationsForRole(roleId).map((staffRoleAllocation, i) => {
                                    let className = i === (this.getStaffRoleAllocationsForRole(roleId).length - 1) ? 'role-border' : 'staff-border';
                                    return <td className={className}>{this.state.hourTotals[staffRoleAllocation.id] ? this.state.hourTotals[staffRoleAllocation.id] : ''}</td>
                                }))
                        })}
                        <td>{this.state.hourGrandTotal ? this.state.hourGrandTotal : ''}</td>
                    </tr>
                    <tr style={{borderBottom : 'solid black 1px'}}>
                        <td>Total Cost</td>
                        {this.state.selectedRoles.map((roleId, i) => {
                            return (
                                this.getStaffRoleAllocationsForRole(roleId).map((staffRoleAllocation, i) => {
                                    let className = i === (this.getStaffRoleAllocationsForRole(roleId).length - 1) ? 'role-border' : 'staff-border';
                                    return <td className={className}>{this.state.costTotals[staffRoleAllocation.id] ? '$' + this.state.costTotals[staffRoleAllocation.id].toLocaleString('en-NZ', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''}</td>
                                }))
                        })}
                        <td id="staff_cost_grand_total" data-value={this.state.costGrandTotal}>{this.state.costGrandTotal ? '$' + this.state.costGrandTotal.toLocaleString('en-NZ', {minimumFractionDigits: 2, maximumFractionDigits: 2}) : ''}</td>
                    </tr>
                    {Object.values(this.state.lineItems).sort((o,o2) => o.sort - o2.sort).map((v) => {
                        return  (

                            <ProposalRow
                                key={v.id}
                                lineItemId={v.id}
                                v={v}
                                selectedRoles={this.state.selectedRoles}
                                getStaffRoleAllocationsForRole={this.getStaffRoleAllocationsForRole}
                                getHoursForRoleStaffFromLineItem={this.getHoursForRoleStaffFromLineItem}
                                onDescriptionChange={this.onDescriptionChange}
                                onHoursChange={this.onHoursChange}
                                onDateRangeChange={this.onDateRangeChange}
                                handleDeleteLineItemButtonClick={this.handleDeleteLineItemButtonClick}
                                moveRow={this.moveLineItem}
                                setAllocationCoordinates={this.setAllocationCoordinates}
                                selectedAllocationCoordinates={this.state.selectedAllocationCoordinates}
                                index={v.sort}
                                id={v.id}
                                dateData={this.state.dateData}
                            />

                        );
                    })}
                    <tr>
                        <td>
                            <a onClick={_disabled ? null : (e) => this.handleAddLineItemButtonClick(e)} title="Add Line Item" className="js-add_collection_entry" href="#">+</a> <a href="#" onClick={_disabled ? null : (e) => this.handleAddLineItemButtonClick(e)}>Add Line Item</a>
                            <span style={{padding: '0 0.5em 0 0.5em'}}>|</span>
                            <a onClick={_disabled ? null : (e) => this.handlePasteLineItemsButtonClick()
                            } title="Paste Line Items" href="#">Paste Line Items</a>
                        </td>
                    </tr>

                    </tbody>
                </table>
            </div>
            </form>

        );
    }

    getStaffUtilisationBasedOnDateSelections = (staffRoleAllocation) => {
        // let callName = this.state.allStaffLookup[staffRoleAllocation.staff]?.callName;
        if (!this.state.staffUtilisationDaily) return {allocatedHoursForPeriod: 0, periodDays: 0, periodHours: 0};
        let startDate = this.state.dateData.startDate;
        // const staffUtilisationFilteredSummary = {...this.state.staffUtilisationSummary};

        // if (!this.state.staffUtilisationDaily[callName]) return {};

        //need to get start and end date indexes for this staff member
        //go through each line item, see if it has allocations for that staff member. If so, need to get the start and end date index of that line item in relation to the propasal start date

        let startEndDateIndexes = Object.values(this.state.lineItems)
            .filter(lineItem => Object.values(lineItem.allocations).some(allocation => allocation.staffRoleAllocation === staffRoleAllocation.id))
            .map(lineItem => [lineItem.startDate.diff(startDate, 'days'), lineItem.endDate.diff(startDate, 'days')])


        if (startEndDateIndexes.length === 0) return this.state.staffUtilisationSummary;





        return Object.fromEntries(Object.entries(this.state.staffUtilisationDaily).map(([i, e]) => [i, e.reduce((daySummaryPrev, daySummaryCurr, i) => {
            if (startEndDateIndexes.some(([startIndex, endIndex]) => i >= startIndex && i <= endIndex)) {
                return {
                    allocatedHoursForPeriod: daySummaryPrev.allocatedHoursForPeriod + daySummaryCurr.allocatedHoursForPeriod,
                    periodDays: daySummaryPrev.periodDays + daySummaryCurr.periodDays,
                    periodHours: daySummaryPrev.periodHours + daySummaryCurr.periodHours,
                    totalUtilisationPercent: (daySummaryPrev.allocatedHoursForPeriod + daySummaryCurr.allocatedHoursForPeriod) /
                                             (daySummaryPrev.periodHours + daySummaryCurr.periodHours) * 100
                }
            }
            return daySummaryPrev;
        }, {allocatedHoursForPeriod: 0, periodDays: 0, periodHours: 0})]));
    }
    handlePasteLineItemsButtonClick = () => {
        navigator.clipboard.readText().then(text => {
            return text.replace('\r\n', '\n').split('\n').map(lineText => lineText.split('\t'));
        }).then(lineItemsArr => {
            lineItemsArr.forEach((lineItemArr) => {
                if (lineItemArr.length === 1 && !lineItemArr[0]) return;
                const lineItemId = this.handleAddLineItemButtonClick(null, lineItemArr[0]);

                var i = 0;
                this.state.selectedRoles.forEach((role) => {
                    this.getStaffRoleAllocationsForRole(role).forEach(staffRoleAllocation => {
                        this.modifyHoursAllocation(lineItemId, staffRoleAllocation, lineItemArr[i + 1]);
                        i = i + 1;
                    })
                })
            })
        });
    }

    setAllocationCoordinates = (e, index, roleIndex, sraIndex) => {
        if (e) {
            const newLineIndexes = [...e.target.value.matchAll(new RegExp('\n', 'gi'))].map(a => a.index)

            const firstNewLineIndex = newLineIndexes[0] || -1;
            const lastNewLineIndex = newLineIndexes[newLineIndexes.length - 1] || -1;
            // const lastNewLineIndex = e.target.value.lastIndexOf('\n');
            // const firstNewLineIndex = e.target.value.indexOf('\n');
            const cursorPosition = e.target.selectionStart;
            const isLastSra = this.getStaffRoleAllocationsForRole(this.state.selectedRoles[roleIndex])?.length === (sraIndex + 1) ;
            const highestSraIndexForPreviousRole = this.getStaffRoleAllocationsForRole(this.state.selectedRoles[roleIndex - 1])?.length - 1;
            const isLastRoleIndex = this.state.selectedRoles.length === (roleIndex + 1);


            if (e.key === 'ArrowDown' && cursorPosition > lastNewLineIndex) index = Math.min(index + 1, Object.values(this.state.lineItems).length);
            if (e.key === 'ArrowUp' && (cursorPosition <= firstNewLineIndex || firstNewLineIndex === -1)) index = Math.max(index - 1, 0);
            if (e.key === 'ArrowLeft' && (cursorPosition === 0 || newLineIndexes.some(e => e === cursorPosition - 2)))
                [sraIndex, roleIndex] = [sraIndex === 0 ? highestSraIndexForPreviousRole : sraIndex - 1, sraIndex === 0 ? roleIndex - 1 : roleIndex]
            if (e.key === 'ArrowRight' && (cursorPosition === (e.target.value.length) || newLineIndexes.some(e => e === cursorPosition)))
                [sraIndex, roleIndex] = [isLastSra && !isLastRoleIndex ? 0 : sraIndex + 1, isLastSra || sraIndex === -1 ? roleIndex + 1 : roleIndex]
        }

        this.setState({
            selectedAllocationCoordinates: {y: index, roleIndex: roleIndex, sraIndex: sraIndex}
        })
    }

}

// function StaffSelection(props) {
//     const staffOnRole = props.staffOnRole;
//     const allStaffLookup = props.allStaffLookup;
//     const allStaffIdSorted = props.allStaffIdSorted;
//     const currentRole = props.currentRole;
//     const onStaffChange = props.onStaffChange;
//     const handleDeleteStaffButtonClick = props.handleDeleteStaffButtonClick;
//
//     // console.log(staffOnRole);
//     // const staffToList = staffOnRole.length ? staffOnRole : [-1];
//     // console.log(staffToList);
//
//     return staffOnRole.map((staffId, i) => {
//         let className = i === (staffOnRole.length - 1) ? 'role-border' : 'staff-border';
//         return (
//                 <td className={className} style={{'padding' : '0, 0.2em'}}>
//                     <div style={{'white-space' : 'nowrap'}}>
//                         <select style={{width: 9 +'em'}} onChange={(e) => onStaffChange(currentRole,i, e)}>
//                             <option>Select a staff member...</option>
//                             {allStaffIdSorted.map((v) => {
//                                 return allStaffLookup[v]['role'] == currentRole  &&
//                                     (!staffOnRole.find(s => s == v) || v == staffId) ? (
//                                                 <option selected={(staffId == v) ? 'selected' : ''}
//                                                         value={v}>{allStaffLookup[v].firstName + ' ' + allStaffLookup[v].lastName}
//                                                 </option>) : ''
//                             })}
//                         </select>
//                         <a href='#' onClick={(e) => handleDeleteStaffButtonClick(staffId, i, e)} className='js-delete_collection_entry'>x</a>
//                     </div>
//                 </td>
//         )
//     });
// }

class StaffRoleSelectionPopup extends React.Component {
    //we want a select list that lists
    //Role: Staff Nam0e
    constructor (props) {
        super(props);
        this.allStaffSorted = props.allStaffSorted;
        this.allRolesSorted = props.allRolesSorted;
        this.allStaffLookup = props.allStaffLookup;
        this.allRoles = props.allRoles;
        this.allSelectedStaff = props.allSelectedStaff;
        this.handleOnStaffRoleSelectionChange = props.handleOnStaffRoleSelectionChange;
        this.selectRef = React.createRef();
        this.divRef = React.createRef();
        this.staffUtilisationSummary = props.staffUtilisationSummary;

        this.state ={
            x: 100
        };

    }

    componentDidMount() {
        // console.log(this.selectRef);
        this.selectRef.current.focus();
        // console.log(this.divRef.current.getBoundingClientRect());
        // console.log(this.divRef);
        this.setState({
                'x': this.divRef.current.getBoundingClientRect().x
            }
        )

    }
    // const options = [
    //     { value: 'chocolate', label: 'Chocolate' },
    //     { value: 'strawberry', label: 'Strawberry' },
    //     { value: 'vanilla', label: 'Vanilla' }
    // ];
    render () {
        return (
            <div ref={this.divRef} style={{
                position:"absolute",
                top: '2.2em',
                left:this.state.x > 50 ? null : '0',
                right:'-4px',
                zIndex: '4',
                // backgroundColor: '#bbbbbbef',
                // padding: "50px",
                margin: 0,
                width: '500px'}}>
                <StaffRoleSelection
                    hideRoles={true}
                    selectRef={this.selectRef}
                    allSelectedStaff={this.allSelectedStaff}
                    handleOnStaffRoleSelectionChange={this.handleOnStaffRoleSelectionChange}
                    allStaffSorted={this.allStaffSorted}
                    allRolesSorted={this.allRolesSorted}
                    allStaffLookup={this.allStaffLookup}
                    allRoles={this.allRoles}
                    staffUtilisationSummary={this.staffUtilisationSummary}
                />
            </div>
        )
    }
}

function StaffRoleSelection(props) {
    const {hideRoles = false, showRoleAsValue = false, small = false, selectRef, allRolesSorted, handleOnStaffRoleSelectionChange, allSelectedStaff, allSelectedRoles, currentStaffId, currentRoleId, staffUtilisationSummary = {}, hoursToBeBooked = 0, currentStaffRoleAllocationId = null, rolesAtTopMode = null, hideStaffOfSelectedRoles = null} = props;
    var allStaffSorted = props.allStaffSorted;


    const styles = small ? smallSelect2Styles
     : undefined;


    allStaffSorted = allStaffSorted.filter(staff => staff.active || staff.id == currentStaffId);
    var roleIdToPrioritise = currentRoleId || allStaffSorted.find(s => s.id == currentStaffId)?.role;
    var allStaffSameRole = allStaffSorted.filter(staff => staff.role == roleIdToPrioritise);
    allStaffSorted = allStaffSorted.filter(staff => staff.role != roleIdToPrioritise);
    if (staffUtilisationSummary) {
        let sorter = function(a, b) {
            let availableB = staffUtilisationSummary[b.callName]?.periodHours - staffUtilisationSummary[b.callName]?.allocatedHoursForPeriod;
            let availableA = staffUtilisationSummary[a.callName]?.periodHours - staffUtilisationSummary[a.callName]?.allocatedHoursForPeriod;
            if (availableB < availableA) return -1;
            if (availableB > availableA) return 1;
            return 0;
        }

        allStaffSorted = allStaffSorted.sort(sorter);
        allStaffSameRole = allStaffSameRole.sort(sorter);


        allStaffSorted = [...allStaffSameRole, ...allStaffSorted];
    }

    if (roleIdToPrioritise && allRolesSorted && !rolesAtTopMode) {
        let currentRoleName = allRolesSorted.find(r => r.id == roleIdToPrioritise);
        let roleNameArr = currentRoleName.name.split(' ');
        const roleNameToSearch  = roleNameArr[0] + (roleNameArr[1] ? ' ' + roleNameArr[1] : '');
        var recommendedRoles = allRolesSorted.filter(r => {
            return r.name.search(roleNameToSearch) >= 0;
        });
    }

    // const unassignedIndex = allStaffSorted.findIndex(o => o.id === 0);
    // allStaffSorted.unshift(...allStaffSorted.splice(unassignedIndex,1));
    var staffOptions = [];
    var priorityOptions = [];



    allStaffSorted.forEach((staff) => {
        // if (!staff.active && currentStaffId != staff.id) return;

        if (hideStaffOfSelectedRoles && allSelectedRoles && allSelectedRoles.includes(staff.role)) return;
        if (allSelectedStaff && (allSelectedStaff.find(s => s == staff.id) && currentStaffId != staff.id)) return;

        let roleStr = allRolesSorted.find(o => staff.role === o.id)?.name || '';
        let selectObject = {
            value: 'staff' + '_' + staff.id,
            label: staff['firstName'] + ' ' +
                staff['lastName'] + (roleStr ? '___' + roleStr : ''),
            role: (roleStr ? roleStr : ''),
            utilisationPercent: (staff.id == 0 ? null : staffUtilisationSummary[staff.callName]?.totalUtilisationPercent),
            hoursAvailable: staffUtilisationSummary && staffUtilisationSummary[staff.callName] && staff.id > 0 ?
                staffUtilisationSummary[staff.callName].periodHours - staffUtilisationSummary[staff.callName].allocatedHoursForPeriod : null,
        };

        if ((recommendedRoles && recommendedRoles.some(r => staff.role == r.id)) || (!showRoleAsValue && currentStaffId == 0 && staff.id == 0)) {
            priorityOptions.push(selectObject);
            return;
        }

        staffOptions.push(selectObject);

    });




    let roleOptions = allRolesSorted.filter(role => currentRoleId == role.id || !allSelectedRoles || !allSelectedRoles.includes(role.id)).map(role => {
        return {
            roleId: role.id,
            value: 'role' + '_' + role.id,
            label: role['name']
        };
    });
    if (currentRoleId && showRoleAsValue && priorityOptions && !rolesAtTopMode) {
        const currentRoleSelectIndex = roleOptions.findIndex(s => s.roleId == currentRoleId);
        priorityOptions.unshift(...roleOptions.splice(currentRoleSelectIndex,1));
    }
    var options = [
        {
            label: "Staff",
            options: staffOptions
        },
        {
            label: "Roles",
            options: roleOptions
        },
    ];
    if (rolesAtTopMode) {
        options = [
            {
                label: "Roles",
                options: roleOptions
            },
            {
                label: "Staff",
                options: staffOptions
            },
        ];
    }
    if (hideRoles) {
        options = [
            {
                label: "Staff",
                options: staffOptions
            },
        ];
    }
    if (priorityOptions.length) {
        options.unshift(
            {
                label: "Recommended",
                options: priorityOptions
            }
        )
    }
    const formatOptionLabel = ({ value, label, role = null, utilisationPercent = null, hoursAvailable = null }, {context}) => (
        <div>
            <div title='Hours Available' style={{float: 'right', position: 'relative', backgroundColor: context == 'menu' ? 'transparent' : 'white', 'paddingLeft': '2px',  fontSize: '0.9em', color: hoursAvailable - hoursToBeBooked >= 0 ? '#666' : '#c66'}}>
                {/*{utilisationPercent !== null ? Number(utilisationPercent).toFixed(0) + '%' : ''}*/}
                {hoursAvailable !== null ? Number(context == 'menu' ? hoursAvailable : hoursAvailable - hoursToBeBooked).toFixed(1) + 'h' : ''}
            </div>
            <div style={{ display: "flex", flexDirection: "column", flexGrow: 1}}>
                <div style={{width:'100%'}}>{label.split('___')[0]}</div>
                {  context == 'menu' ? ( <div style={{ fontSize: '0.8em', color: "#999" }}>
                    {role}
                </div>) : '' }
            </div>
        </div>
    );

    var value = (
        showRoleAsValue && currentRoleId && currentStaffId == 0 ?
            options[2]?.options.find(v => v?.value === 'role' + '_' + currentRoleId) || options[0].options.find(v => v?.value === 'role' + '_' + currentRoleId) :
            (options[0].options.find(v => v?.value === 'staff' + '_' + currentStaffId) || options[1]?.options.find(v => v?.value === 'staff' + '_' + currentStaffId))
    );

    return <Select isDisabled={_disabled} formatOptionLabel={formatOptionLabel} value={value} styles={styles} ref={selectRef} onChange={e => handleOnStaffRoleSelectionChange(e, currentStaffId, currentRoleId, currentStaffRoleAllocationId)} options={options} />
}



function renderProposalCharges(disabled = false) {
    _disabled = disabled;
    window._disabled = disabled;

    if (document.getElementById('estimationWidget')) {
        ReactDOM.render(
            <DndProvider backend={HTML5Backend}>
                <Proposal date={date} clientID={clientID} proposalID={proposalID} startDate={startDate} endDate={endDate} />
            </DndProvider>,
            document.getElementById('estimationWidget')
        );

        // ReactDOM.unmountComponentAtNode(document.getElementById('estimationWidget'));


        // if (disabled) {
        //     var old_element = document.getElementById("estimationWidget");
        //     var new_element = old_element.cloneNode(true);
        //     old_element.parentNode.replaceChild(new_element, old_element);
        //
        //     let elements = document.querySelectorAll('#estimationWidget input, #estimationWidget textarea');
        //     console.log(elements);
        //     Array.prototype.forEach.call(elements, function (v, i) {
        //         v.disabled = true;
        //     });
        //     let as = document.querySelectorAll('#estimationWidget a');
        //     Array.prototype.forEach.call(as, function (v, i) {
        //         v.style.cursor = 'pointer';
        //     });
        // }
    }
}
window.renderProposalCharges = renderProposalCharges;
function renderStaffRoleSelectionForNode(props) {
    const currentProps = props;
    props.reassignmentHours = props.hoursToBeBooked - props.actualHours;
    ReactDOM.render(
        <div>
            { props.reassignmentMessage ? <span style={{fontSize: '0.8em'}}>Reassigning will split this task. </span> : '' }
            { props.reassignmentMessage && props.reassignmentHours !== null ? <span style={{fontSize: '0.8em'}}>New task hours: {Math.max(props.reassignmentHours,0)}</span> : '' }
            { props.reassignmentMessage ? <div style={{fontSize: '0.8em'}}>Please ensure the reassigned role has enough budget allocated.</div> : '' }
            {/*{ props.reassignmentMessage && props.enableNewTaskToggle ? <div style={{fontSize: '0.8em'}}><a className={'addTask'} href={''}>Click here</a> to split this task now.</div> : '' }*/}
            <StaffRoleSelection
                handleOnStaffRoleSelectionChange={props.handleOnStaffRoleSelectionChange}
                allSelectedRoles={window.allSelectedRoles}
                hideStaffOfSelectedRoles={props.hideStaffOfSelectedRoles}
                allStaffSorted={props.allStaffSorted}
                allRolesSorted={props.allRolesSorted}
                currentStaffId={props.currentStaffId}
                currentRoleId={props.currentRoleId}
                staffUtilisationSummary={props.staffUtilisationSummary}
                hoursToBeBooked={props.hoursToBeBooked}
                small={props.small}
                showRoleAsValue={true}
                rolesAtTopMode={props.rolesAtTopMode}
            />
        </div>

            ,
        props.node
    )
}

let getAdjustedStaffLists = function(jobId, enqId) {
    let allStaffSorted = [...window.allStaffSorted];
    let allStaffLookup = [];
    allStaffSorted.forEach(staff => {

        let matchingStaffOverride = window.staffRoleAllocations.find((sra) =>
            sra.staff == staff.id && (sra.job == jobId || sra.enquiry == enqId)
        )
        if (matchingStaffOverride)
            staff.role = Number(matchingStaffOverride.role);

        allStaffLookup[staff.id] = staff;
    });

    return [allStaffSorted, allStaffLookup];
}
let bootstrapStaffAndRoleLists = () => {
    if (!window.allStaffSorted) {
        var allStaffSorted = [];
        var allStaffLookup = [];
        var ajax = new XMLHttpRequest();
        ajax.open("GET", '/staff/list?showInactive=1', false);
        ajax.onload = () => {
            var response = JSON.parse(ajax.responseText);

            response.forEach(function(e) {
                allStaffLookup[e.id] = new Staff(e.id, e.firstName, e.lastName, e.role, e.callName, e.team, e.contractor, e.active, e.leaderOf);
                allStaffSorted.push(allStaffLookup[e.id]);
            });

            // allStaffLookup.sort((a, b) => {
            //    a.callName > b.callName;
            // });
            window.allStaffSorted = allStaffSorted;
            window.allStaffLookup = allStaffLookup;


        };
        ajax.send();
    }
    if (!window.allRolesSorted) {
        var allRolesSorted = [];
        var allRolesLookup = [];
        var ajax = new XMLHttpRequest();
        ajax.open("GET", '/admn/roles/get_list', false);
        ajax.onload = () => {
            var response = JSON.parse(ajax.responseText);
            response.forEach(function(e) {
                allRolesLookup[e.id] = new Role(e.id, e.name, 0);
                allRolesSorted.push(allRolesLookup[e.id]);
            });
            window.allRolesLookup = allRolesLookup;
            window.allRolesSorted = allRolesSorted;
        };
        ajax.send();
    }
}
window.bootstrapStaffAndRoleLists = bootstrapStaffAndRoleLists;

var setupNodeForRoleSelection = (node, jobId) => {
    if (!node) return;
    if (!window.RoleProps) window.RoleProps = {};

    var currentRoleNode =  node.querySelector('input[type="hidden"]');

    if (!currentRoleNode) return;

    var allocationId = currentRoleNode.id;


    bootstrapStaffAndRoleLists();

    var reactRootNode = node.getElementsByClassName('staffRoleSelectionWidget')[0];

    var handleOnStaffRoleSelectionChange = (e) => {
        const [roleOrStaff, id] = e.value.split('_');

        if (roleOrStaff == 'role') {
            var roleId = id;
        } else {
            var roleId = window.allStaffLookup[id].role;
        }

        let previousRoleId = currentRoleNode.value;
        currentRoleNode.value = roleId;

        window.RoleProps[allocationId].currentRoleId = roleId;

        renderStaffRoleSelectionForNode(window.RoleProps[allocationId]);



        e.target = currentRoleNode;
        getStandardRate(e, previousRoleId);


    }

    [allStaffSorted, allStaffLookup] = getAdjustedStaffLists(jobId, null);

    window.RoleProps[allocationId] = {
        allocationId: allocationId,
        allStaffSorted : allStaffSorted,
        allRolesSorted : window.allRolesSorted,
        currentRoleId: currentRoleNode.value,
        hideStaffOfSelectedRoles: true,
        currentStaffId: 0,
        rolesAtTopMode: true,
        small: false,
        node: reactRootNode,
        handleOnStaffRoleSelectionChange: handleOnStaffRoleSelectionChange
    }

    renderStaffRoleSelectionForNode(window.RoleProps[allocationId]);
}
var setupNodeForStaffSelection = (node, taskId, small = true, disableUtilisation = false, enableNewTaskToggle = false) => {
    // console.log('hello');
    if (!node) return;
    if (!window.StaffRoleProps) window.StaffRoleProps = {};

    // var currentRoleNode =  node.querySelector('#app_bundle_task_type_role');
    // var currentStaffNode =  node.querySelector('#app_bundle_task_type_staffAllocatedto');
    var currentRoleNode =  node.querySelector('input.role');
    var currentStaffNode =  node.querySelector('input.staffAllocatedto');

    if (!currentStaffNode || !currentRoleNode) return;

    var reactRootNode = node.getElementsByClassName('staffRoleSelectionWidget')[0];
    // var dateRangeNode =  node.querySelector('#app_bundle_task_type_dateRange');
    var dateRangeNode =  node.querySelector('input.dateRange');
    var allocatedHoursNode = node.querySelector('input.allocatedHours');
    // var allocatedHoursNode = node.querySelector('#app_bundle_task_type_allocatedHours');

    if (!taskId) taskId = allocatedHoursNode.dataset.id || justNumbers(node.dataset.index);



    bootstrapStaffAndRoleLists();

    /**
     *
     * @param dateRange (d/m/Y to d/m/Y)
     * @param taskId
     */
    var getStaffUtilisation = (dateRange, taskId) => {
        if (disableUtilisation) return;
        var ajax = new XMLHttpRequest();
        var staffUtilisationSummary;
        ajax.open("GET", '/tasks/get_utilisation?exclTask=' + taskId + '&task_filter[dateRange]=' + dateRange, false);
        ajax.onload = () => {
            staffUtilisationSummary = JSON.parse(ajax.responseText).staffUtilisationSummary;
        };
        ajax.send();

        return staffUtilisationSummary;

    };




    var handleOnStaffRoleSelectionChange = (e) => {
        window.StaffRoleProps[taskId].reassignmentMessage = false;
        window.StaffRoleProps[taskId].reassignmentHours = null;
        let props = window.StaffRoleProps[taskId];

        let previousRoleId = currentRoleNode.value;
        let previousStaffId = currentStaffNode.value;

        const [roleOrStaff, id] = e.value.split('_');
        if (id == 0) return;
        if (roleOrStaff == 'role') {
            var updateValues = true;

            if (props.taskId && props.actualHours > 0 && props.jobId
                && (props.originalRoleId != id)) {
                props.reassignmentMessage = true;

                if (props.enableNewTaskToggle) {
                    props.reassignmentRole = id;
                    props.reassignmentStaff = 0;
                    updateValues = false;
                }
            }
            if (updateValues) {
                currentRoleNode.value = id;
                currentStaffNode.value = 0;
                window.StaffRoleProps[taskId].currentRoleId = id;
                window.StaffRoleProps[taskId].currentStaffId = 0;
            }
        } else {
            var updateValues = true;

            if (props.taskId && props.actualHours > 0 && props.jobId
                && (props.originalStaffId != id)) {
                props.reassignmentMessage = true;

                if (props.enableNewTaskToggle) {
                    props.reassignmentStaff = id;
                    props.reassignmentRole = null;
                    updateValues = false;
                }
            }
            if (updateValues) {
                currentStaffNode.value = id;
                currentRoleNode.value = null;
                window.StaffRoleProps[taskId].currentRoleId = null;
                window.StaffRoleProps[taskId].currentStaffId = id;
            }


        }


        const currentProps = window.StaffRoleProps[taskId];
        //if there are actualHours, and the staff has a different role to the original

        renderStaffRoleSelectionForNode(window.StaffRoleProps[taskId]);

        window.dispatchEvent(new CustomEvent('taskstaffchanged', {detail : {taskId: taskId, previousStaffId: previousStaffId, previousRoleId: previousRoleId }}));
    }

    let [allStaffSorted, allStaffLookup] = getAdjustedStaffLists(allocatedHoursNode.dataset.jobid, allocatedHoursNode.dataset.enqid);

    window.StaffRoleProps[taskId] = {
        enableNewTaskToggle: enableNewTaskToggle,
        taskId: taskId,
        allStaffSorted : allStaffSorted,
        allStaffLookup: allStaffLookup,
        allRolesSorted : window.allRolesSorted,
        currentStaffId : currentStaffNode.value,
        currentRoleId: currentRoleNode.value,
        originalStaffId : currentStaffNode.value,
        originalRoleId: currentRoleNode.value,
        hoursToBeBooked: allocatedHoursNode.value,
        reassignmentHours: null,
        actualHours: allocatedHoursNode.dataset.actualhours,
        jobId: allocatedHoursNode.dataset.jobid,
        small: small,
        node: reactRootNode,
        handleOnStaffRoleSelectionChange: handleOnStaffRoleSelectionChange
    }

    dateRangeNode.addEventListener('change', (e) => {
        if (e.target.value.indexOf('to') !== -1) {
            setTimeout(() => {
                    window.StaffRoleProps[taskId].staffUtilisationSummary = getStaffUtilisation(e.target.value, taskId);
                    renderStaffRoleSelectionForNode(window.StaffRoleProps[taskId])
            }
                , 150);
        }
    });

    allocatedHoursNode.addEventListener('input', (e) => {
        window.StaffRoleProps[taskId].hoursToBeBooked = e.target.value;
        renderStaffRoleSelectionForNode(window.StaffRoleProps[taskId]);
    });
    renderStaffRoleSelectionForNode(window.StaffRoleProps[taskId]);

    if (dateRangeNode.value.indexOf('to') !== -1) {
        setTimeout(() => {
            window.StaffRoleProps[taskId].staffUtilisationSummary = getStaffUtilisation(dateRangeNode.value, taskId);
            renderStaffRoleSelectionForNode(window.StaffRoleProps[taskId]);
        }, 150)
    }


}
window.renderStaffRoleSelectionForNode = renderStaffRoleSelectionForNode;
window.setupNodeForStaffSelection = setupNodeForStaffSelection;
window.setupNodeForRoleSelection = setupNodeForRoleSelection;
export { Staff, Role }
